import * as actions from "../action.constants";

const initialState = {
  probes_types: [],
  slave_list: [],
};

const storeAdvancedProbeTypes = (state, action) => {
  return {
    ...state,
    probes_types: action.payload,
  };
};

const storeSlaveList = (state, action) => {
  return {
    ...state,
    slave_list: action.payload,
  };
};

const handlers = {
  [actions.STORE_ADVANCED_PROBE_TYPES]: storeAdvancedProbeTypes,
  [actions.STORE_SLAVE_LIST]: storeSlaveList,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
